import ichraCheck from "../../assets/ichraCheck.svg"
import qsehraCheck from "../../assets/qsehraCheck.svg"
import shadedI from "../../assets/shadedI.svg"
import shadedQ from "../../assets/shadedQ.svg"

const ichraBullets = [
	"Only employees with individual health insurance or Medicare can participate",
	"Gives employees more choice in their health plans",
	"Lets the employer set a budget and control costs"
]

const qsehraBullets = [
	"All employees participate, regardless of how they get their health insurance",
	"Includes employees with individual health insurance or Medicare, as well as those covered by a spouse's plan, COBRA, and other government coverage",
	"Lets the employer set a budget and control costs"
]

export default function ChooseHRA() {
	return (
		<section id="choose_hra">
			<div className="container">
				<h2 className="section-heading choose-hra__title">Choose the Right HRA</h2>

				<div className="row choose-hra__cards">
					<div className="col-12 col-md-6">
						<div className="hra-card hra-card--ichra">
							<img src={shadedI} alt="" className="hra-card__bg-letter" />
							<span className="hra-card__badge hra-card__badge--ichra">ICHRA</span>
							<h3 className="hra-card__heading">Alternative to group health coverage</h3>
							<p className="hra-card__intro">
								Use an ICHRA if you want an alternative to traditional group health coverage.
							</p>
							<ul className="hra-card__bullets">
								{ichraBullets.map((bullet) => (
									<li key={bullet}>
										<img src={ichraCheck} alt="" className="hra-card__check" />
										<span>{bullet}</span>
									</li>
								))}
							</ul>
							<a href="/learning-center/ichra-administration" className="hra-card__cta hra-card__cta--ichra">
								Learn About ICHRA <span aria-hidden="true">→</span>
							</a>
						</div>
					</div>

					<div className="col-12 col-md-6">
						<div className="hra-card hra-card--qsehra">
							<img src={shadedQ} alt="" className="hra-card__bg-letter" />
							<span className="hra-card__badge hra-card__badge--qsehra">QSEHRA</span>
							<h3 className="hra-card__heading">Health benefits for all employees</h3>
							<p className="hra-card__intro">Use a QSEHRA if you want to offer health benefits to all employees.</p>
							<ul className="hra-card__bullets">
								{qsehraBullets.map((bullet) => (
									<li key={bullet}>
										<img src={qsehraCheck} alt="" className="hra-card__check" />
										<span>{bullet}</span>
									</li>
								))}
							</ul>
							<a href="/learning-center/qsehra-administration" className="hra-card__cta hra-card__cta--qsehra">
								Learn About QSEHRA <span aria-hidden="true">→</span>
							</a>
						</div>
					</div>
				</div>

				<p className="choose-hra__compare">
					Still Deciding?{" "}
					<a
						href="https://salusion.com/learning-center/ichra-vs-qsehra-comparison/"
						className="choose-hra__compare-link"
					>
						Compare ICHRA Vs QSEHRA <span aria-hidden="true">→</span>
					</a>
				</p>
			</div>
		</section>
	)
}
